import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { PlacementBoard } from '@/features/placement/PlacementBoard'

import { AdminHeader } from '../AdminLayout'
import { useAdminContext } from '../session'

/**
 * Le placement des tables, côté back-office.
 *
 * C'est ici qu'on prépare la salle avant la soirée : chaque réservation payée
 * reçoit sa table, et on peut la changer jusqu'au dernier moment. Le soir J,
 * la même liste vit dans l'écran Salle (`/ops/service`, onglet Placement), au
 * téléphone de l'hôtesse — mêmes gestes, mêmes refus, une seule vérité.
 */
export function AdminPlacementPage() {
  const { t } = useTranslation()
  const { eventId, can } = useAdminContext()

  useEffect(() => {
    document.title = t('admin.section.placement')
  }, [t])

  return (
    <>
      <AdminHeader
        title={t('admin.section.placement')}
        description={t('admin.placement.description')}
        action={
          <Link
            to="/ops/service?tab=placement"
            className="text-sm text-champagne-300 underline underline-offset-2"
          >
            {t('admin.placement.openFloor')}
          </Link>
        }
      />
      <PlacementBoard
        eventId={eventId}
        canUpdate={can('tables.placement.update')}
        variant="admin"
      />
    </>
  )
}
